import { Button, Card, Col, Row } from 'react-bootstrap';
import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import html2pdf from 'html2pdf.js';
import logoImg from '../../assets/images/logo-light.png';

const PrintFinYear = ({ data, user }) => {
    let { dia, extra, faltas, dvrest, dvtotal, tlvac, tlprima, tlnaldo,tlqn } = data;
    let { inicio_labores, fin_labores } = user;
    let periodo = moment(data.inicio).format('LL') + ' al ' + moment(data.fin).format('LL');
    const [totalF, setTotal] = useState(0);
    const contentRef = useRef();
    useEffect(() => {
        let diasServicio = 0;

        const inicioLaboresMoment = moment(inicio_labores, 'YYYY-MM-DD'); // Parseando la fecha correctamente
        const finLaboresMoment = moment(fin_labores, 'YYYY-MM-DD'); // Parseando la fecha correctamente

        if (!inicioLaboresMoment.isValid()) {
            console.error('Fecha de inicio de labores no es válida');
        } else {
            diasServicio = moment(finLaboresMoment).diff(inicioLaboresMoment, 'days');
            diasServicio += 1;
        }
        let total;
        if (diasServicio >= 15) {
            total = Math.round(dia * 15);
        } else {
            total = Math.round(dia * diasServicio);
        }
        if (extra > 0) {
            total += extra * dia * 2;
        }
        if (faltas > 0) {
            let totalFaltas = dia * 1.16 * faltas;
            total -= totalFaltas;
        }
        if (data.tlqn > 0) {
            setTotal(data.tlqn);
        } else {
            setTotal(total);
        }
    }, [data]);
    const handleGeneratePdf = () => {
        const element = contentRef.current;

        const opt = {
            filename: 'documento.pdf', // Nombre del archivo PDF
            margin: [10, 10, 10, 10], // [top, left, bottom, right]
            html2canvas: {
                useCORS: true, // Habilitar el uso de CORS (opcional, necesario si hay problemas con las imágenes)
                scale: 2,
            },
            jsPDF: {
                orientation: 'portrait',
            },
        };

        const loadImages = () => {
            const images = element.getElementsByTagName('img');
            const totalImages = images.length;
            let imagesLoaded = 0;

            return new Promise((resolve, reject) => {
                if (totalImages === 0) {
                    resolve();
                } else {
                    for (let i = 0; i < totalImages; i++) {
                        images[i].addEventListener('load', () => {
                            imagesLoaded++;
                            if (imagesLoaded === totalImages) {
                                resolve();
                            }
                        });
                        images[i].addEventListener('error', () => {
                            reject(new Error('Error loading images'));
                        });
                        // En caso de que la imagen ya esté cargada en caché
                        if (images[i].complete) {
                            imagesLoaded++;
                            if (imagesLoaded === totalImages) {
                                resolve();
                            }
                        }
                    }
                }
            });
        };

        loadImages()
            .then(() => {
                html2pdf()
                    .from(element)
                    .set(opt)
                    .output('blob')
                    .then((pdfBlob) => {
                        // Crear un objeto URL para el PDF
                        const pdfUrl = URL.createObjectURL(pdfBlob);

                        // Abrir el PDF en una nueva pestaña para imprimir
                        const pdfWindow = window.open(pdfUrl);
                        pdfWindow.addEventListener('load', () => {
                            pdfWindow.print();
                        });
                    });
            })
            .catch((error) => {
                console.error('Error generating PDF:', error);
            });
    };

    return (
        <Col>
            <Card>
                <div className="d-print-none mt-4">
                    <div className="text-end">
                        <button className="btn btn-primary me-1" onClick={handleGeneratePdf}>
                            <i className="mdi mdi-printer"></i>Imprimir
                        </button>
                    </div>
                </div>
                <Card.Body>
                    <div id="print" className="print-content" ref={contentRef}>
                        <div className="clearfix">
                            <div className="float-start mb-3">
                                <img src={logoImg} alt="logo" height="25" crossOrigin="anonymous" />
                            </div>
                            <div className="float-end">
                                <h4 className="m-0 d-print-none">Nomina</h4>
                            </div>
                        </div>

                        <Row>
                            <Col>
                                <div className="mt-3 text-center">
                                    <p className="font-13">
                                        <strong className="text-uppercase">
                                            DESGLOSE DE NOMINA DE FIN DEL AÑO {moment().format('YYYY')}
                                        </strong>
                                    </p>
                                </div>
                            </Col>
                        </Row>

                        <Row className="mt-1">
                            <Col sm={4}>
                                <h5>Empleado: {user.nombre}</h5>
                            </Col>
                            <Col sm={4}>
                                <h5>Sueldo por dia: ${dia}</h5>
                            </Col>
                            <Col sm={4}>
                                <h6>Fecha de impresión: {moment().format('YYYY-MM-DD')}</h6>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <div className="mt-4">
                                    <strong>{periodo}</strong>
                                    <table className="table  table-bordered border-secondary table-responsive ">
                                        <thead className="table-secondary">
                                            <tr>
                                              
                                                <th>Sueldo quincenal</th>
                                                <th>Faltas</th>
                                                <th>Dia pagado no laborable</th>
                                                <th>Descuento del dia</th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                              
                                                <td>${Math.round(tlqn).toFixed(2)}</td>
                                                <td>{data.faltas}</td>
                                                <td>
                                                    Dias: {data.extra} ---${data.extra * data.dia * 2}
                                                </td>
                                                <td>{(data.dia * 1.16 * data.faltas).toFixed(2)}</td>
                                                <td>${Math.round(tlqn).toFixed(2)}</td>
                                            </tr>
                                            <tr className="fs-5">
                                                <td
                                                    colSpan="4 "
                                                    className="text-end border border-secondary  fw-bolder text-bg-warning table-light">
                                                    <div className="d-flex justify-content-between">
                                                        <span> Dias de vacaciones:{dvtotal}</span>
                                                        <span> Vacaciones tomadas:{dvrest}</span>
                                                        <span>Vacaciones pagadas({dvtotal - dvrest}):</span>
                                                    </div>
                                                </td>

                                                <td className="text-end fw-bolder border border-secondary">
                                                    ${Math.round(tlvac).toFixed(2)}
                                                </td>
                                            </tr>
                                            <tr className="fs-5">
                                                <td
                                                    colSpan="4 "
                                                    className="text-end border border-secondary  fw-bolder text-bg-warning table-light">
                                                    Prima vacacional:
                                                </td>

                                                <td className="text-end fw-bolder border border-secondary">
                                                    ${Math.round(tlprima).toFixed(2)}
                                                </td>
                                            </tr>
                                            <tr className="fs-5">
                                                <td
                                                    colSpan="4 "
                                                    className="text-end border border-secondary  fw-bolder text-bg-warning table-light">
                                                    Aguinaldo:
                                                </td>

                                                <td className="text-end fw-bolder border border-secondary">
                                                    ${Math.round(tlnaldo).toFixed(2)}
                                                </td>
                                            </tr>

                                            <tr className="fs-5">
                                                <td
                                                    colSpan="4 "
                                                    className="text-end border border-secondary  fw-bolder text-bg-warning table-light">
                                                    <div className="d-flex justify-content-between">
                                                        <spann>Pago en transferencia:${data.transferencia}</spann>
                                                        <spann>
                                                            {' '}
                                                            Pago en efectivo: $
                                                            {((totalF+tlnaldo+tlprima+tlvac) - data.transferencia).toFixed(2)}
                                                        </spann>
                                                        <spann>TOTAL:</spann>
                                                    </div>
                                                </td>

                                                <td className="text-end fw-bolder border border-secondary">
                                                    ${Math.round(totalF+tlnaldo+tlprima+tlvac).toFixed(2)}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="text-center">
                                    <hr style={{ width: '50%', height: '5px', margin: '20px auto', color: 'black' }} />
                                    <h5>Firma del empleado</h5>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Card.Body>
            </Card>
        </Col>
    );
};

export default PrintFinYear;
